module.exports = __webpack_public_path__ + "menu.png?0ffbbb510b81d47265d86687249aafdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/menu.png
// module id = 165
// module chunks = 0